import request from '@/axios/index.js'
export function contractList(data,loading) {
    return request.axios({
        url: `/invoiceMainContract/findInvoiceMainContractList`,
        data: data,
        loading:loading
    })
}

export function contractAdd(data) {
    return request.axios({
        url: `/invoiceMainContract/saveOrUpdateInvoiceMainContract`,
        data: data
    })
}

export function contractDownload(data) {
    return request.axios({
        url: `/invoiceMainContract/invoiceMainContractDownLoad`,
        data: data
    })
}

//修改判断
export function updateMainContractFlag(id) {
    return request.axios({
        url: `/invoice/contract/updateMainContractFlag/${id}`,
    })
}






// WEBPACK FOOTER //
// ./src/api/contract.js